import { combineReducers } from "redux";
import user from "./user/user.reducers";

const appReducer = combineReducers({
  user, 
});
const initialState = appReducer({}, {});
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = initialState;
  }

  return appReducer(state, action);
};

export default rootReducer;
